export const STORAGE_RECOVER_PASSWORD = '@NSW/recuperar-senha'
export const STORAGE_RECOVER_PASSWORD_USERNAME = '@LiviaRecoverPassword:UserName'
export const STORAGE_RECOVER_PASSWORD_PHONE = '@LiviaRecoverPassword:Phone'
export const STORAGE_RECOVER_PASSWORD_TOKEN = '@LiviaRecoverPassword:Token'
export const STORAGE_CURRENT_LABORATORY = '@nav/currentLaboratory'
